// @flow
import * as React from 'react';
import styled from 'styled-components';
import Opportunity from 'common/modules/proposition/domain/opportunity';
import OpportunityCard from '../../components/OpportunityCard';

const Wrapper = styled.div`
  div:first-child {
    margin-top: 0px;
  }
`;

type Props = {
  opportunities: Array<Opportunity>,
}

function SalesPrintingListing(props: Props) {
  const { opportunities } = props;
  return (
    <Wrapper>
      {opportunities.map(opportunity => (
        <OpportunityCard
          opportunity={opportunity}
          index={opportunity.queryId}
          printing
          key={opportunity.queryId}
        />))
      }
    </Wrapper>
  );
}

export default SalesPrintingListing;



// WEBPACK FOOTER //
// ./src/common/modules/sales/components/printing/SalesPrintingListing.js